var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusWarning = function SvgStatusWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 0.01,
    fill: "#C3BD8D",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M5 11.673h3.506a.05.05 0 0 0 .048-.036l.69-2.314a.05.05 0 0 1 .096 0l1.661 5.527c.015.047.082.047.096 0l2.584-8.681c.014-.048.082-.048.096 0l1.67 5.469a.05.05 0 0 0 .047.035H19M5 18.01h14"
  })));
};
export default SvgStatusWarning;